import { VAT_OPTIONS_TYPE, VatOptionType } from "types/Vat";

export const VAT_OPTIONS: VatOptionType[] = [
  { title: "Do not charge VAT", value: VAT_OPTIONS_TYPE.NONE },
  { title: "Including VAT", value: VAT_OPTIONS_TYPE.INCLUDED, description: "VAT included in product price" },
  { title: "Excluding VAT", value: VAT_OPTIONS_TYPE.EXCLUDED, description: "VAT included in total price" },
];
